import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfigService } from '../config/app-config.service';

export const baseUrlInterceptor: HttpInterceptorFn = (
  req,
  next
) => {

  const config =
    inject(AppConfigService);

  if (
    /^https?:\/\//i.test(req.url) ||
    req.url.startsWith('assets/') ||
    req.url.startsWith('/assets/') ||
    req.url.startsWith('./') ||
    req.url.startsWith('../')
  ) {
    return next(req);
  }

  const apiBaseUrl =
    config.apiBaseUrl.replace(/\/+$/, '');

  const normalizedUrl =
    req.url.startsWith('/')
      ? req.url
      : `/${req.url}`;

  return next(
    req.clone({
      url:
        `${apiBaseUrl}${normalizedUrl}`
    })
  );
};